import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [3];

export const dictionary = {
		"/(brand)": [4,[2]],
		"/app": [10,[3]],
		"/app/actions": [11,[3]],
		"/app/borrow": [12,[3]],
		"/app/connect-wallet": [13,[3]],
		"/app/earn": [14,[3]],
		"/app/history": [15,[3]],
		"/app/markets": [16,[3]],
		"/app/markets/details": [17,[3]],
		"/app/portfolio": [18,[3]],
		"/app/positions": [19,[3]],
		"/app/positions/[txHash]/[outputIndex]": [20,[3]],
		"/app/swap": [21,[3]],
		"/(brand)/company": [5,[2]],
		"/(brand)/contact": [6,[2]],
		"/(brand)/notices": [7,[2]],
		"/(brand)/platform": [8,[2]],
		"/(brand)/roadmap": [9,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';